import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
  Slide,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { colors } from "../../../theme/designTokens";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Standardizes the fullScreen Dialog + Slide + AppBar/Toolbar-as-header
// convention previously hand-rolled in each medicine Add/Edit dialog.
export default function FullScreenFormDialog({
  open,
  onClose,
  onCloseIcon,
  title,
  children,
  headerActions,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative", bgcolor: colors.white, color: colors.ink }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onCloseIcon || onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1, fontWeight: 700 }} variant="h6" component="div">
            {title}
          </Typography>
          {headerActions && <Box>{headerActions}</Box>}
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Box sx={{ maxWidth: { xs: "100%", lg: 1400 }, mx: "auto" }}>
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
